const wix = (id, w, h) => `https://static.wixstatic.com/media/${id}/v1/fill/w_${w},h_${h},al_c,q_85/img.jpg`;

export const landings = {
  "trades-promotion": {
    label: "Trades Promotion",
    titleA: "Promo videos built",
    titleB: "for the trades.",
    seoTitle: "Trades Promo Videos & Photography in Essex | WVE Studios",
    seoDesc: "Cinematic promo videos, testimonials and photography for builders, plumbers, electricians and architects in Essex. Stand out, win more work — WVE Studios, Wickford.",
    heroImg: wix("1fe187_6d8347661f904b93bf18363936b493c7~mv2.jpg", 900, 1000),
    intro: [
      "Our team at WVE Studios are experts at creating beautiful cinematic videos and photos of your latest project!",
      "By incorporating elements such as testimonials, project showcases, and before-and-after visuals, WVE ensures that each promo video serves as a potent tool for professionals in these trades to distinguish themselves in a competitive market and establish meaningful connections with their target audience.",
      "WVE Studios is a leading provider of promotional videos specifically tailored for professionals in the building, plumbing, architecture, and electrical sectors.",
    ],
    sections: [
      {
        title: "Video Showrounds & Testimonials",
        paragraphs: [
          "Video testimonials and showround videos are essential in the construction industry for building trust, showcasing expertise, and differentiating companies in a competitive market.",
          "Video testimonials offer a genuine and personal endorsement from satisfied clients, establishing credibility and fostering trust. Showround videos provide a dynamic visual representation of completed projects, construction processes, and craftsmanship, engaging potential clients and allowing them to assess a company's capabilities firsthand.",
          "The immersive nature of video content not only captures attention but also serves as a powerful marketing tool, helping construction companies stand out and communicate their unique strengths, ultimately influencing potential clients' decision-making processes.",
        ],
        video: "ykASclNX5aI",
        videoLabel: "HJJ Developments Project Build — Promo Video",
      },
      {
        title: "Photography",
        paragraphs: [
          "Photos are crucial in the construction industry as they serve as a visual record of every stage of a project, providing a comprehensive documentation of the construction process.",
          "High-quality photos capture the intricate details of architectural designs, structural elements, and workmanship, serving as a valuable reference for both builders and clients. These images are essential for progress tracking, quality control, and project management.",
          "Additionally, construction photos play a pivotal role in marketing and communication — showcasing completed projects, attracting potential clients, and establishing a portfolio that highlights a construction company's capabilities and expertise.",
        ],
        images: [wix("1fe187_65ec5a9d2fb74e3fbb272ee5c84c385f~mv2.jpg", 800, 500), wix("1fe187_285f369b76f84c8593158045a813a601~mv2.jpg", 800, 500)],
      },
    ],
    cta: "Trades Promotion",
  },
  "funeral-live-stream": {
    label: "Funeral Live Stream",
    titleA: "Bringing loved ones",
    titleB: "together, wherever they are.",
    seoTitle: "Funeral Live Streaming in Essex | WVE Studios",
    seoDesc: "Discreet two-camera HD funeral live streaming on a private, personalised webpage — £695 per service including keepsake HD footage. WVE Studios, Essex.",
    heroImg: wix("1fe187_bfde6626560f43608f55d988a4d008d1~mv2.jpg", 900, 1000),
    price: "£695",
    priceNote: "Per service, for up to 45 minutes — including the HD footage as a keepsake.",
    intro: [
      "We supply a two-camera live HD stream on a dedicated webpage that we create. This is not a public live stream and is only accessible from the direct link you provide to family and friends.",
      "We also personalise the page with text, photos and the order of service to provide the virtual audience with a great viewing experience.",
      "Our team works quietly and discreetly, ensuring the service is captured respectfully so that those who can't be there in person never have to miss the chance to say goodbye.",
    ],
    sections: [
      {
        title: "How it works",
        paragraphs: [
          "We create a private, password-free webpage accessible only via a direct link that you share with family and friends — personalised with text, photos and the order of service.",
          "On the day, two discreet HD cameras capture the service, live-mixed and streamed in real time. Afterwards, we supply you with the full HD footage as a lasting keepsake.",
        ],
        images: [wix("1fe187_481a8a13f3de4952aaff045d4f35f0f0~mv2.jpg", 800, 500), "https://static.wixstatic.com/media/3c85d3427cc74f57bf47dd8d2697586c.jpg/v1/fill/w_800,h_500,al_c,q_85/roses.jpg"],
      },
    ],
    cta: "Funeral Live Stream",
  },
  "estate-agent": {
    label: "Estate Agent Media",
    titleA: "Property media that",
    titleB: "sells homes faster.",
    seoTitle: "Estate Agent Property Videos & Photography in Essex | WVE Studios",
    seoDesc: "Property sale media packs for estate agents — cinematic video showrounds, drone shots and professional photography that win instructions and sell properties quicker. WVE Studios, Essex.",
    heroImg: wix("1fe187_047c47a58b1f49fb828b5195816465a0~mv2.jpg", 900, 1000),
    intro: [
      "Our team at WVE Studios are experts at creating beautiful cinematic videos and photos of your latest property!",
      "By incorporating drone shots, professional photos and video showarounds, WVE ensures that each property listing has all the ingredients to be a success on the market.",
      "WVE Studios is a leading provider of promotional videos & photography specifically tailored for marketing your properties online.",
    ],
    sections: [
      {
        title: "Video Showrounds",
        paragraphs: [
          "Property tour videos are essential in the estate agency industry for building trust, showcasing expertise, and standing out in a competitive market.",
          "These videos provide dynamic visual walkthroughs of homes and developments, engaging potential buyers or tenants and allowing them to explore properties from the comfort of their own homes.",
          "The immersive nature of video content not only captures attention but also serves as a powerful marketing tool — helping agents win new instructions and sell properties quicker.",
        ],
        video: "vOfjHWXeZyo",
        videoLabel: "Foxton Road, Grays, Essex — Property Tour",
      },
      {
        title: "Photography",
        paragraphs: [
          "Photos are crucial in the estate agency industry as they provide a visual representation of properties, creating a strong first impression for potential buyers or tenants.",
          "High-quality photos capture the key features, design details, and unique selling points of a property — helping showcase its potential, attract interest, and set it apart in a competitive market.",
          "Property photos play a pivotal role in generating leads and building an agent's portfolio, demonstrating expertise and the ability to present homes in the best possible light.",
        ],
        images: [wix("1fe187_65ec5a9d2fb74e3fbb272ee5c84c385f~mv2.jpg", 800, 500), wix("1fe187_6d8347661f904b93bf18363936b493c7~mv2.jpg", 800, 500)],
      },
    ],
    cta: "Estate Agent Media",
  },
  "artist-development": {
    label: "Artist Development",
    titleA: "Ready for your",
    titleB: "next step?",
    seoTitle: "Artist Development Packages from £1,250 | WVE Studios",
    seoDesc: "Recording, music videos, photo shoots, vocal coaching and worldwide distribution. Our team has worked with Sam Smith, Ella Eyre, Pixie Lott & more. Packages from £1,250 — WVE Studios, Essex.",
    heroImg: wix("1fe187_24b5ec3af06e429cb590f32b252162d9~mv2_d_3276_4096_s_4_2.jpg", 900, 1000),
    price: "From £1,250",
    priceNote: "Development packages bespoke to your artistic requirements.",
    intro: [
      "WVE Studios (formerly KALM Creative) is a creative hub for artists, bands, songwriters and producers ready to take the next step in the industry.",
      "Our team have worked with household names such as Sam Smith, Ella Eyre, Pixie Lott, Rylan Clark and Louisa Johnson to name a few.",
      "We offer recording and writing sessions, photo shoots, music videos, vocal training, performance and confidence coaching, worldwide music distribution, industry advice and social media development.",
    ],
    sections: [
      {
        title: "Bespoke Music Videos",
        paragraphs: [
          "From concept to final cut, our team produces bespoke music videos that give your release the visual identity it deserves — shot on broadcast-quality kit with creative direction included.",
        ],
        video: "5_FhnaXA1KA",
        videoLabel: "D'LuXE — Biggest Mistake (Official Video)",
      },
      {
        title: "Music Distribution",
        paragraphs: [
          "Our registered record label is responsible for over 40 releases with combined unit sales/streams of over 100,000 copies on iTunes, Amazon Music and Spotify to name a few.",
          "Our videos across social platforms including YouTube, Facebook and Instagram have amassed well over ONE MILLION views to date.",
        ],
        images: [wix("1fe187_85b8816e0b9945e6b0526396fc5a0bee~mv2.jpg", 800, 500), wix("1fe187_44fa251bc99b4da69460908fd6ca0ab7~mv2.png", 800, 500)],
      },
      {
        title: "What's Included",
        paragraphs: ["Professional studio recording · Writing sessions · Bespoke music videos · Professional photo shoots · Vocal training · Performance & confidence coaching · Worldwide music distribution · Industry advice · Social media development"],
      },
    ],
    cta: "Artist Development",
  },
  "video-production-chelmsford": {
    label: "Video Production Chelmsford",
    titleA: "Video production",
    titleB: "in Chelmsford.",
    seoTitle: "Video Production Chelmsford | WVE Studios",
    seoDesc: "Professional video production in Chelmsford — business promos, live streams, event filming & photography from WVE Studios. Trusted by BAFTA, Shell, Ferrari & F1. Call 01277 280 512.",
    heroImg: wix("1fe187_3633287a6f614c5aba2a841f9cc5f1b6~mv2_d_2048_1462_s_2.jpg", 900, 1000),
    intro: [
      "Looking for a video production company in Chelmsford? WVE Studios delivers broadcast-quality video, photography and live streaming across Chelmsford and the surrounding area — with 20+ years of combined industry experience.",
      "Our team has produced content for BAFTA, Shell, Ferrari, F1, the BBC, Amazon Prime Video and West Ham United — and we bring exactly the same kit and crew to every Chelmsford business, school and event.",
      "From multi-camera event filming and business promos to live streams on Teams, Zoom or YouTube, everything is produced in-house by our Essex-based team, just a short trip from Chelmsford.",
    ],
    sections: [
      {
        title: "What we deliver in Chelmsford",
        paragraphs: [
          "Business promo videos and photography that win customers — every package includes both a photo and video shoot. Multi-camera live streaming with 12× Blackmagic cameras, vision mixing and wired + 5G failover internet, broadcast to Microsoft Teams, Zoom, YouTube or your webinar platform.",
          "We also film dance and theatre shows, produce full events (staging, sound & lighting, AV), create artist showreels from £399 and offer studio hire at our Wickford HQ — around 30 minutes from Chelmsford.",
          "Every project gets a single point of contact from first cue to final credit, bespoke pricing for any budget, and two revisions included on every edit.",
        ],
        images: [wix("1fe187_1bff1689ce7149e283c29ddc48e0cadf~mv2.jpg", 800, 500), wix("1fe187_10271d2ec705417193776b42aaaf4c94~mv2.jpg", 800, 500)],
      },
    ],
    cta: "Video Production Chelmsford",
  },
  "video-production-southend": {
    label: "Video Production Southend-on-Sea",
    titleA: "Video production",
    titleB: "in Southend-on-Sea.",
    seoTitle: "Video Production Southend-on-Sea | WVE Studios",
    seoDesc: "Professional video production in Southend-on-Sea — business promos, live streams, event filming & photography from WVE Studios. Trusted by BAFTA, Shell, Ferrari & F1. Call 01277 280 512.",
    heroImg: wix("1fe187_3633287a6f614c5aba2a841f9cc5f1b6~mv2_d_2048_1462_s_2.jpg", 900, 1000),
    intro: [
      "Looking for a video production company in Southend-on-Sea? WVE Studios delivers broadcast-quality video, photography and live streaming across Southend-on-Sea and the surrounding area — with 20+ years of combined industry experience.",
      "Our team has produced content for BAFTA, Shell, Ferrari, F1, the BBC, Amazon Prime Video and West Ham United — and we bring exactly the same kit and crew to every Southend-on-Sea business, school and event.",
      "From multi-camera event filming and business promos to live streams on Teams, Zoom or YouTube, everything is produced in-house by our Essex-based team, just a short trip from Southend-on-Sea.",
    ],
    sections: [
      {
        title: "What we deliver in Southend-on-Sea",
        paragraphs: [
          "Business promo videos and photography that win customers — every package includes both a photo and video shoot. Multi-camera live streaming with 12× Blackmagic cameras, vision mixing and wired + 5G failover internet, broadcast to Microsoft Teams, Zoom, YouTube or your webinar platform.",
          "We also film dance and theatre shows, produce full events (staging, sound & lighting, AV), create artist showreels from £399 and offer studio hire at our Wickford HQ — around 30 minutes from Southend-on-Sea.",
          "Every project gets a single point of contact from first cue to final credit, bespoke pricing for any budget, and two revisions included on every edit.",
        ],
        images: [wix("1fe187_1bff1689ce7149e283c29ddc48e0cadf~mv2.jpg", 800, 500), wix("1fe187_10271d2ec705417193776b42aaaf4c94~mv2.jpg", 800, 500)],
      },
    ],
    cta: "Video Production Southend-on-Sea",
  },
  "video-production-brentwood": {
    label: "Video Production Brentwood",
    titleA: "Video production",
    titleB: "in Brentwood.",
    seoTitle: "Video Production Brentwood | WVE Studios",
    seoDesc: "Professional video production in Brentwood — business promos, live streams, event filming & photography from WVE Studios. Trusted by BAFTA, Shell, Ferrari & F1. Call 01277 280 512.",
    heroImg: wix("1fe187_3633287a6f614c5aba2a841f9cc5f1b6~mv2_d_2048_1462_s_2.jpg", 900, 1000),
    intro: [
      "Looking for a video production company in Brentwood? WVE Studios delivers broadcast-quality video, photography and live streaming across Brentwood and the surrounding area — with 20+ years of combined industry experience.",
      "Our team has produced content for BAFTA, Shell, Ferrari, F1, the BBC, Amazon Prime Video and West Ham United — and we bring exactly the same kit and crew to every Brentwood business, school and event.",
      "From multi-camera event filming and business promos to live streams on Teams, Zoom or YouTube, everything is produced in-house by our Essex-based team, just a short trip from Brentwood.",
    ],
    sections: [
      {
        title: "What we deliver in Brentwood",
        paragraphs: [
          "Business promo videos and photography that win customers — every package includes both a photo and video shoot. Multi-camera live streaming with 12× Blackmagic cameras, vision mixing and wired + 5G failover internet, broadcast to Microsoft Teams, Zoom, YouTube or your webinar platform.",
          "We also film dance and theatre shows, produce full events (staging, sound & lighting, AV), create artist showreels from £399 and offer studio hire at our Wickford HQ — around 30 minutes from Brentwood.",
          "Every project gets a single point of contact from first cue to final credit, bespoke pricing for any budget, and two revisions included on every edit.",
        ],
        images: [wix("1fe187_1bff1689ce7149e283c29ddc48e0cadf~mv2.jpg", 800, 500), wix("1fe187_10271d2ec705417193776b42aaaf4c94~mv2.jpg", 800, 500)],
      },
    ],
    cta: "Video Production Brentwood",
  },
  "video-production-london": {
    label: "Video Production London",
    titleA: "Video production",
    titleB: "in London.",
    seoTitle: "Video Production London | WVE Studios",
    seoDesc: "Professional video production in London — business promos, live streams, event filming & photography from WVE Studios. Trusted by BAFTA, Shell, Ferrari & F1. Call 01277 280 512.",
    heroImg: wix("1fe187_3633287a6f614c5aba2a841f9cc5f1b6~mv2_d_2048_1462_s_2.jpg", 900, 1000),
    intro: [
      "Looking for a video production company in London? WVE Studios delivers broadcast-quality video, photography and live streaming across London and the surrounding area — with 20+ years of combined industry experience.",
      "Our team has produced content for BAFTA, Shell, Ferrari, F1, the BBC, Amazon Prime Video and West Ham United — and we bring exactly the same kit and crew to every London business, school and event.",
      "From multi-camera event filming and business promos to live streams on Teams, Zoom or YouTube, everything is produced in-house by our Essex-based team, just a short trip from London.",
    ],
    sections: [
      {
        title: "What we deliver in London",
        paragraphs: [
          "Business promo videos and photography that win customers — every package includes both a photo and video shoot. Multi-camera live streaming with 12× Blackmagic cameras, vision mixing and wired + 5G failover internet, broadcast to Microsoft Teams, Zoom, YouTube or your webinar platform.",
          "We also film dance and theatre shows, produce full events (staging, sound & lighting, AV), create artist showreels from £399 and offer studio hire at our Wickford HQ — around 30 minutes from London.",
          "Every project gets a single point of contact from first cue to final credit, bespoke pricing for any budget, and two revisions included on every edit.",
        ],
        images: [wix("1fe187_1bff1689ce7149e283c29ddc48e0cadf~mv2.jpg", 800, 500), wix("1fe187_10271d2ec705417193776b42aaaf4c94~mv2.jpg", 800, 500)],
      },
    ],
    cta: "Video Production London",
  },
};
